import React from 'react';
import "./dataManagement.scss";
import Facilited from './sections/facilited';
import Reconcile from './sections/reconcile';
import Benefits from './sections/benefits';
import AgileConnection from './sections/agileConnection';
import DataIntegrity from './sections/dataIntegrity';
import EasyIntegration from './sections/easyIntegration';
import WhereData from './sections/whereData';

import LetsGo from '../connectors/letsgo'
import { useTranslation } from 'react-i18next';
import MergeData from './sections/mergedata';


function DataManagement() {
  const { t } = useTranslation()
  return (
    <div className='container-data-management'>
      <div className='section-facilited'>
        <Facilited />
      </div>
      <div className='section-reconcile'>
        <Reconcile />
      </div>
      <div className='section-benefits'>
        <Benefits />
      </div>
      <div className='section-agile-connection'>
        <AgileConnection title={t("data_management.agile_connection.title")}>
          <p>{t("data_management.agile_connection.section_text_1")}</p>
          <p>{t("data_management.agile_connection.section_text_2")} </p>
        </AgileConnection>
      </div>
      <div className='section-data-integrity'>
        <DataIntegrity />
      </div>
      <div className='section-easy-integration'>
        <MergeData />
      </div>
      <div className='section-lets-go'>
        <LetsGo />
      </div>
    </div>
  )
}

export default DataManagement;